var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBbSocialLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_271_1215)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 0C17.0752 0 22.0001 4.92486 22.0001 11C22.0001 17.0752 17.0752 22.0001 11 22.0001C4.92486 22.0001 0 17.0752 0 11C0 4.92486 4.92486 0 11 0ZM9.79751 9.16642H11.7047V10.1441L11.7323 10.1442C11.9979 9.66769 12.6474 9.16649 13.6158 9.16649C15.6297 9.16642 16.0022 10.4198 16.0022 12.0501V15.3712L14.0132 15.3713V12.4272C14.0132 11.7254 13.9986 10.822 12.979 10.822C11.9434 10.822 11.7846 11.5859 11.7846 12.3761V15.3713H9.79745V9.16649L9.79751 9.16642ZM8.41864 7.44289C8.41864 8.01379 7.95532 8.47711 7.38442 8.47711C6.81352 8.47711 6.35006 8.01379 6.35006 7.44289C6.35006 6.87199 6.81352 6.40867 7.38442 6.40867C7.95532 6.40867 8.41864 6.87199 8.41864 7.44289ZM6.35006 9.16642H8.41864V15.3713H6.35006V9.16642Z",
    fill: "#0077B5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_271_1215"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBbSocialLinkedin);
export default __webpack_public_path__ + "static/media/bb_social_linkedin.25f21d2fe685dab4d574b66a60fb7346.svg";
export { ForwardRef as ReactComponent };